'use client';

import RtuSection6 from '@enlighten/landing/dist/rtu/@section6';

export default function Section6() {
	return (
		<RtuSection6
			onClick={() => {
				window.open('https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=16730270323609', '_blank');
			}}
		/>
	);
}
